import { Eye, EyeSlash } from 'iconsax-react';
import React, { useState } from 'react';

import { commaThousondSeperator } from '@shared/lib';
import { Label, Star, Tags } from '@shared/ui';

import { goldAssetsLanguages } from '../model';
import { TUserGoldAssetsResponse } from '../api';

export const GoldAssetValue = ({
  totalValue,
  profitPercentage,
  profitAmount,
}: Pick<TUserGoldAssetsResponse, 'profitAmount' | 'profitPercentage' | 'totalValue'>) => {
  const [show, setShow] = useState<boolean>(false);
  return (
    <div className='flex flex-col gap-y-5 justify-center items-center text-nowrap ml-9 '>
      <div className=' flex flex-col gap-y-[10px] justify-center items-center w-fit min-w-[200px]'>
        <div className=' flex items-center justify-center'>
          <p className='text-xs'>{goldAssetsLanguages.assetValue}</p>
          <button
            className=' w-[24px] h-[24px] p-1 rounded-[6px] bg-border text-text mr-1 hover:bg-disableBorder '
            onClick={() => setShow(!show)}
          >
            {!show ? <Eye size='16' /> : <EyeSlash size='16' />}
          </button>
        </div>
        {!show ? (
          <Star length={9} leading='40px' />
        ) : (
          <p className=' leading-[40px] text-[24px] font-bold'>
            {commaThousondSeperator(totalValue)}{' '}
            <span className='body-12-regular'>{goldAssetsLanguages.rial}</span>
          </p>
        )}
      </div>
      <div className='flex h-[66px] flex-col gap-y-[10px] justify-between items-center'>
        <p className='text-xs '>{goldAssetsLanguages.CurrentProfit_loss}</p>
        {!show ? (
          <Star length={9} leading='40px' />
        ) : (
          <div className={`flex flex-row-reverse justify-center items-center gap-x-2 `} dir='ltr'>
            <Label
              className={`text-[24px] font-bold ${
                +profitPercentage < 0
                  ? '!text-red-1 '
                  : +profitPercentage > 0
                    ? '!text-green-1'
                    : ''
              }`}
            >
              {commaThousondSeperator(profitAmount)}
            </Label>
            <Tags
              title={''}
              className={`  !h-[26px] ${
                +profitPercentage < 0
                  ? '!bg-red-1 '
                  : +profitPercentage > 0
                    ? '!bg-green-1'
                    : '!bg-gray'
              }`}
            >
              <Label className='!text-white'>{profitPercentage} % </Label>
            </Tags>
          </div>
        )}
      </div>
    </div>
  );
};
